  // Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

  // Import Swiper styles
import 'swiper/css';
import { ImgWrapper } from 'components/ImgContainer/ImgWrapper';
import { AllImagePack } from './gallary.allImagePack';
import React, { useState } from 'react';
import { Controller, FreeMode, Keyboard, Pagination, Thumbs } from 'swiper';
import { Box, styled } from '@mui/material';
import { Icon } from 'components/Icons';
import { useBreak } from 'hooks/useBreak';
import { Transition } from './Gallery.style';

export const GallarySwiper = ({ images, setActiveGlry, activeGlry  }) => {
  let totalImgCount = 0
  const isDesktop = useBreak("md_up");

  // Swiper variables
  const [swiper, setSwiper] = useState(null);
  const [swiperThumbs, setSwiperThumbs] = useState(null);

  // Swiper function
  const handlePrev = () => {
    swiper.slidePrev();
  };

  const handleNext = () => {
    swiper.slideNext();
  };

  const handleClickThumb = (ind) => {
    swiper.slideTo(ind);
  };
  // Swiper function
  
  // Gallary handle functions
  const handleGallaryImages = ({ PID, PIN, PIDINDEX }) => {
    setActiveGlry({
      glryPin: PIN,
      glryPid: PID, 
      glryPidIndex: PIDINDEX
    })
  }

  return (
    <Box sx={{ position: "relative", 
        // "& .swiper": {overflow:"visible"}, 
    "& .swiper-slide": { width: "auto !important", height: isDesktop ? "250px" : "100%", paddingBottom: "50px", marginTop: "10px" }, 
    "& .swiper .swiper-pagination .swiper-pagination-bullet": { background: clr.primary}}}>
      <Swiper
        pagination={isDesktop ? true : false}
          onSwiper={setSwiper}
        //   spaceBetween  = {16}
          slidesPerView = {isDesktop ? 4 : 'auto'}
        //   onSlideChange = {() => console.log('slide change')}
          modules={[FreeMode, Keyboard, Thumbs, Controller, Pagination]}
          >
            <SwiperSlide style={{ transform: "unset" }}>
                <AllImagePack allImages={images} setActiveGlry={setActiveGlry} activeGlry={activeGlry} />
            </SwiperSlide>

            {
                images.map((image, index) => {
                    const keys   = Object.keys(image ?? {})
                    const i_keys = keys.length && Object.keys(image[keys[0]] ?? {})
                    
                        return <React.Fragment key={index}>
                          {
                            Boolean(i_keys.length) && i_keys.map((i_k, i) => {
                                let img_url = image[keys[0]]?.[i_k]?.Data?.ListOfPhotos?.find((au) => au.Description === "Forsidebillede")

                                let isSelected = false

                                if(activeGlry?.glryPidIndex === i_k && activeGlry?.glryPid === keys[0] && activeGlry?.glryPin === index) {
                                    isSelected = true
                                }
                                
                                if(i_keys.length === 1 && !i) totalImgCount += 1
                                else if(i_keys.length !== 1 && i) totalImgCount += 1

                              // if property have only different id like c6, c7
                                if (i_keys.length === 1 && !i) return 
                                <SwiperSlide onClick={ ()=> handleGallaryImages({ PID: keys[0], PIN: index, PIDINDEX: i_k }) } style={{ cursor: "pointer", 
                                // height: "200px", width: isDesktop ? "auto" : "250px"
                                 }} key  = {`${index}+${i}`}>
                                    <Transition isSelected={isSelected}>
                                        {/* <ImageContainer image={image[keys[0]][i]}  /> */}
                                        {
                                             Boolean(img_url?.Url) &&  <ImageContainer image={img_url?.Url}  />
                                        }
                                    </Transition>
                                </SwiperSlide>
        
                                // if property have only type like sales and rent
                                if(i_keys.length !== 1 && i_keys.length > 1 && i) return <SwiperSlide onClick={ ()=> handleGallaryImages({ PID: keys[0], PIN: index, PIDINDEX: i_k }) } style={{ cursor: "pointer", 
                                // height: "200px", width: isDesktop ? "auto" : "250px" 
                                }} key = {`${index}+${i}`} > 
                                <Transition isSelected={isSelected}>
                                    {/* <ImageContainer image={image[keys[0]][i]} /> */}
                                    {
                                        Boolean(img_url?.Url) && <ImageContainer image={img_url}  />
                                    }
                                    <p className={ isSelected ? 'h4' : 'paragraph1-light' }>
                                        { i === 1 ? "Ejerboliger" : 
                                        i === 2 ? "Lejeboliger" :
                                        "" 
                                        }
                                    </p>
                                </Transition>
                                </SwiperSlide>
                                  
                            })
                          }
                        </React.Fragment>
                })
            }
        </Swiper>
      { isDesktop && totalImgCount > 3 &&
        <Box> 
          <Arrow left onClick={handlePrev}>
              <div
                style={{
                  borderRadius: "6px",
                  backgroundColor: clr.primary,
                  display: "flex",
                  height: "32px",
                  width: "32px",
                  padding: "8px 0px",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Icon icon="arrow-left" sx={{ color: "#fff", fontSize: 16 }} />
              </div>
            </Arrow>
            <Arrow right onClick={handleNext}>
              <div
                style={{
                  borderRadius: "6px",
                  backgroundColor: clr.primary,
                  display: "flex",
                  height: "32px",
                  width: "32px",
                  padding: "8px 0px",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Icon icon="arrow-right" sx={{ color: "#fff", fontSize: 16 }} />
              </div>
            </Arrow>
        </Box>
      }
    </Box>
  );
};


const ImageContainer = ({ image }) => {
    return (
        <>
            <ImgWrapper img={image?.Url} style={{ width : "100%",
            height: "auto", borderRadius: '6px', overflow: 'hidden' }} alt={"gallary images"}/>
        </>
    )
}

// STYLES

const Arrow = styled(Box)(({ left, right, UnitDrawer }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  position: "absolute",
  padding: "8px 0px",
  top: "50%",
  borderRadius: left ? "0px 6px 6px 0px" : "6px 0px 0px 6px",
  transform: "translateY(-236%)",
  left: left ? "-48px" : "unset",
  right: right ? "-48px" : "unset",
  width: "32px",
  height: "32px",
  zIndex: 1000,
  cursor: "pointer",
  "& > span": {
    height: 20,
  },
}));

